import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { FC } from 'react'

interface PageGuardGpkPegawaiProps
  extends React.HTMLAttributes<HTMLDivElement> {
  allowOtherRoles?: boolean
}

export const PageGuardGpkPegawai: FC<PageGuardGpkPegawaiProps> = ({
  children,
  allowOtherRoles = false,
}) => {
  const { isLoading: isLoadingRole, isGpkPegawai, leave } = useRoleContext()

  // As the component should not be rendered when still loading the user role, we can just return null
  if (isLoadingRole) return null

  if (!isGpkPegawai && !allowOtherRoles) {
    leave()
    return null
  }

  return <>{children}</>
}
